export const allColors = [
  {
    name: "Blue",
    lightColor: "hover:bg-blue-200",
    darkColor: "text-blue-800",
  },
  {
    name: "Orange",
    lightColor: "hover:bg-orange-200",
    darkColor: "text-orange-800",
  },
  { name: "Red", lightColor: "hover:bg-red-200", darkColor: "text-red-800" },
  {
    name: "Fuchsia",
    lightColor: "hover:bg-fuchsia-200",
    darkColor: "text-fuchsia-600",
  },
  {
    name: "Green",
    lightColor: "hover:bg-green-200",
    darkColor: "text-green-600",
  },
  {
    name: "Purple",
    lightColor: "hover:bg-purple-200",
    darkColor: "text-purple-600",
  },
  { name: "Sky", lightColor: "hover:bg-sky-200", darkColor: "text-sky-600" },

  {
    name: "Rose",
    lightColor: "hover:bg-rose-200",
    darkColor: "text-rose-600",
  },
];
